import React, { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick'
import SliderWrapper from './_SlickSliderStyleDecomposedBanners'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { withTheme } from 'theming'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'
import './decomposedBanners.css'
import AddSection from '../addSection'
import EditMenu from '../editMenu'
import PassimPlayer from '../rosemary/passimPlayer'
import DecomposedSwimlane from './decomposedSwimlane'
import { isEmpty } from 'lodash'

const DecomposedBannerSwimlane = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const sliderRef = useRef(null)
  const { data, id, config } = componentData
  const { customNavigate, getTemplateImage, UpArrow, DownArrow } = useTemplateHook()

  const [hoverState, setHoverState] = useState('')
  const [setting, setSetting] = useState({})

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'flex',
          justifyContent: 'flex-start',
          background: `transaprent`,
          width: '3.56%',
          height: '2.2vw',
          position: 'absolute',
          top: '70%',
          right: '87%',
          content: `url(${DownArrow})`,
          transform: 'rotate(-90deg)',
          // outline: '2px solid hotpink',
        }}
        onClick={onClick}
      >
        NextArrow
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: `transaprent`,
          width: '3.56%',
          height: '2.2vw',
          position: 'absolute',
          top: '70%',
          left: '5%',
          content: `url(${UpArrow})`,
          zIndex: '10',
          transform: 'rotate(-90deg)',
          // outline: '2px solid hotpink',
        }}
        onClick={onClick}
      >
        PrevArrow
      </div>
    )
  }

  useEffect(() => {
    setSetting({
      arrows: true,
      nextArrow: <SampleNextArrow transform={128} />,
      prevArrow: <SamplePrevArrow transform={128} />,
      infinite: true,
      autoplay: data?.auto_slide,
      autoplaySpeed: 3000,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: true,
      overflow: true,
      dots: false,
      adaptiveHeight: true,
    })

    const sliderElement = sliderRef.current

    if (sliderElement) {
      if (data.auto_slide) {
        sliderElement.slickPlay()
      } else {
        sliderElement.slickPause()
      }
    }
  }, [data, theme])

  let swimlaneProps = {
    componentData: {
      data: {
        swimlane_data: data?.swimlane_data,
        style_config: data?.style_config,
        name: data?.name,
      },
    },
    isEdit: isEdit,
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      style={{ background: theme.c1 }}
      className={`w-full relative ${isEdit && hoverState && 'component-hover-class'} z-10  ${
        !isEdit && ' mb-[130px] lg:mb-[180px] 2xl:mb-[130px]'
      }`}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
          position={'top-20 right-4'}
          menuPosition={'top-24 right-4'}
        />
      )}
      <div
        className=" w-full h-full bg-cover bg-center hero-section z-0 mb-[130px] "
        style={{
          overflow: 'visible',
        }}
      >
        <SliderWrapper theme={theme} className="relative " isEdit={isEdit} hoverState={hoverState}>
          <Slider ref={sliderRef} {...setting}>
            {data?.slide_data.map((slide, idx) => (
              <div
                style={{ width: '100%', height: '100%', marginTop: '0px' }}
                key={idx}
                onClick={() => handleRedirect(slide.link)}
              >
                <div
                  className={`relative w-full flex flex-col ${
                    config[slide?.content?.position]
                  }  img-gradient z-0`}
                  style={{ aspectRatio: '2.0253' }}
                >
                  {isEdit || !slide?.player?.type ? (
                    <CustomImage
                      imageUrl={getTemplateImage(slide?.image_s3key)}
                      imgClass={`z-0 w-full absolute top-0`}
                      imgStyle={{ aspectRatio: '2.0253' }}
                      loaderClass="z-0 w-full h-full object-cover absolute"
                      loaderStyle={{
                        background: '#5A5A5A50',
                      }}
                      imgAlt={'class img"'}
                    />
                  ) : (
                    <div className="absolute -z-10 w-full h-full">
                      <PassimPlayer
                        data={slide?.player}
                        poster={getTemplateImage(slide?.image_s3key)}
                        controlBar={false}
                      />
                    </div>
                  )}
                  <div
                    className={`"w-full hidden md:flex drop-shadow z-10  flex-col ${
                      config[slide?.content?.position]
                    } `}
                    style={{
                      padding: '0 5.52%',
                    }}
                  >
                    <div className="  w-[720px]  ">
                      <h1
                        style={{
                          color: getStyleValue('text', 'color', theme.c7),
                          fontFamily: getStyleValue('text', 'font', ''),
                          textAlign: getStyleValue('text', 'alignment', ''),
                        }}
                        className={`text-2xl ${getStyleValue(
                          'text',
                          'font_format',
                          'font-semibold',
                        )}  `}
                      >
                        {slide.content.heading}
                      </h1>
                      <p
                        style={{
                          color: getStyleValue('text', 'color', theme.c7),
                          fontFamily: getStyleValue('text', 'font', ''),
                          textAlign: getStyleValue('text', 'alignment', ''),
                        }}
                        className={`mt-[4px] text-base leading-5 font-normal mb-2 
                      ${getStyleValue('text', 'font_format', '')} 
                      `}
                      >
                        {slide.content.sub_heading}
                      </p>
                      {slide.cta_button.enabled && (
                        <button
                          className="mt-4 font-semibold py-[8px] px-9 border-none rounded-lg tracking-normal"
                          style={{
                            color: getStyleValue('button', 'color', theme.c7),
                            fontFamily: getStyleValue('button', 'font', ''),
                            backgroundColor: getStyleValue('button', 'button_background', theme.c3),
                          }}
                        >
                          {slide.cta_button.text}
                        </button>
                      )}
                    </div>
                  </div>

                  <span
                    style={{
                      background: `transaprent`,
                      width: '3.56%',
                      height: '2.2vw',
                      position: 'absolute',
                      top: '70.5%',
                      left: '1%',
                      // outline: '2px solid hotpink',
                      color: getStyleValue('text', 'color', 'white'),
                    }}
                    className="lg:block hidden"
                  >
                    {' '}
                    {idx + 1} / {data?.slide_data.length}
                  </span>
                </div>
              </div>
            ))}
          </Slider>
          <div
            className="absolute w-full bottom-[-130px] md:bottom-[-160px] lg:bottom-[-180px] xl:bottom-[-140px] 2xl:bottom-[-90px]"
            style={{ zIndex: isEdit ? 0 : 10 }}
          >
            <DecomposedSwimlane
              {...swimlaneProps}
              disableCardHover={true}
              customRedirect={handleRedirect}
            />
          </div>
        </SliderWrapper>
      </div>

      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(DecomposedBannerSwimlane)
